import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../hooks/hooks";
import PageLoader from "../../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";
import Table from "../../../../../common/components/table-manager/v1.1/table";
import { MdTableView } from "react-icons/md";
import { edgeGateways } from "../../../../../redux/edge/gateways/action";
import { selectEdgeGatewaysListItems } from "../../../../../redux/edge/gateways/selector";



const BppGateways = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const listEdgeGatewaysData = useSelector(selectEdgeGatewaysListItems)
   const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      {
        field: 'SubscriberId', headerName: 'Subscriber Id', searchField: 'SubscriberId', filter: true,
        filterType: 'text'
      },
      { field: 'Type', headerName: 'Type', searchField: 'Type', filter: true, filterType: 'text' },
      { field: 'Status', headerName: 'Status', searchField: 'Status', filter: true, filterType: 'text' },
      {
        field: 'Domains', headerName: 'Domains', searchField: 'Domains', filter: true,
        filterType: 'text'
      },
      { field: 'ValidFrom', headerName: 'Valid From', isDateValueFormat: true },
      { field: 'ValidUntil', headerName: 'Valid Until', isDateValueFormat: true },
      { field: '', headerName: 'Edit Config', sortable: false, filter: false, cellRenderer: 'customFunctions' },

    ]);
  }

  
  const filterTypes = [{
    name: 'Text', value: "text"
  },
  {
    name: 'Number', value: "number"
  },
  {
    name: 'CheckBox', value: "checkbox"
  },
  {
    name: 'Date', value: "date"
  }
  ]


  
  const handleSearch = async (data: any) => {
    console.log('Search data', data)
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }

    await fetchEdgeGateways(searchCriteria)
  }

  const handleReloadData = async() => {
    await fetchEdgeGateways()
  }
  
  const fetchEdgeGateways = (searchCriteria: any = undefined) => {
    dispatch(edgeGateways.resetAction({actionType:'list'}))  
    dispatch(edgeGateways.list({
      url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/identity/gateway/gateways/fetch`, entity: 'edgeGateways', jsonData: {

        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "UniqueId",
        "SortOrder": "desc",
        "Searches": searchCriteria

      }
    }))
  }


  const handleEdit = (data: any) => {
    // navigate(`${data.Id}`)
    navigate(`/gateway/commerce/bpp/${data.UniqueId}`)
  }
  const additionButtons: any = [
    // {
    //   svg:
    //     <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
    //       <title>Sync</title>
    //       <path
    //         d="M12 2v2a8 8 0 1 1-7.11 11H2a10 10 0 1 0 10-10zM12 22v-2a8 8 0 1 1 7.11-11H22a10 10 0 1 0-10 10z"
    //         fill="none"
    //         stroke="currentColor"
    //         stroke-width="2"
    //         stroke-linecap="round"
    //         stroke-linejoin="round"
    //       />
    //     </svg>,
    //   callback: () => handlesync(),
    // },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    },
  ];

  const handleViewList = (data: any) => {
    console.log('itemDetails', data)
    navigate(`/gateway/commerce/bpp/${data.SubscriberId}`)
  }

  const handleShowSettings = (data: any) => {
    navigate(`/gateway/settings/commerce/bpp/${data.SubscriberId}`)
  }

  const customFunctions = [
    { icon: <MdTableView className="text-gray-800 text-xl" />, callback: handleShowSettings, title: "Show Settings" },
    // {icon: <MdTableView className="text-gray-800 text-xl" />, callback: handleSpecificationAttributeOptions, title: "Show Specification Attribute Options"},
  ];

  useEffect(() => {
    createColumnDefs()
    dispatch(edgeGateways.resetAction({actionType:'list'}))  
    dispatch(edgeGateways.resetAction({actionType:'query'}))  
    fetchEdgeGateways()
  }, [pageData, pageSize])

  const handleDelete = async (data: any) => {
    
    // Include delete API call

    await fetchEdgeGateways()

  }

  const handlesync = async () => {
   
    // include synch API call

    await fetchEdgeGateways()

  }

  useEffect(() => {
    console.log('listEdgeGatewaysData', listEdgeGatewaysData)
  }, [listEdgeGatewaysData]);


  return (
    <>
      {listEdgeGatewaysData?.isLoading ? <PageLoader /> :
        <Table enableFilter={true}
          filterTypeLists={filterTypes}
          onSearch={handleSearch}
          columnData={columnDefs}
          rowData={listEdgeGatewaysData?.result?.items}
          setPageData={setPageData}
          paginationData={listEdgeGatewaysData?.result?.pagination}
          additionButtons={additionButtons}
          customFunctions={customFunctions}
          onEdit={handleEdit}
          onDelete={handleDelete}
          setPageSize={setPageSize}
          onViewList={handleViewList}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'UniqueId',
          }}
          headingName="DIGIIT Commerce BBP Gateways" />
      }
    </>
  );
};

export default BppGateways;


